module.exports = __webpack_public_path__ + "static/media/pic_winie2_05.fa8316a9.png";